import DropdownMenu from "./DropdownMenu";
import Notifications from "./Notifications";
import SearchContent from "./SearchContent";
import Breadcrumb from "./Breadcrumb";
import PageContent from "./PageContent";
import SwitchProject from "./SwitchProject";

const layoutComponents = {
  DropdownMenu,
  Notifications,
  SearchContent,
  Breadcrumb,
  PageContent,
  SwitchProject
}

export default layoutComponents